import React, { useState } from "react";
import { ChevronRight, ChevronLeft } from "react-feather";

export const Locations = () => {
    const [activeLocation, setActiveLocation] = useState(0);
    const locations = reactConfig.franchise_cities || [];

    const nextLocation = () => {
        if (activeLocation === locations.length - 1) {
            setActiveLocation(0);
            return;
        }
        setActiveLocation(activeLocation + 1);
    };

    const previousLocation = () => {
        if (activeLocation === 0) {
            setActiveLocation(locations.length - 1);
            return;
        }
        setActiveLocation(activeLocation - 1);
    };

    return (
        <div className="franchise-locations">
            <div className="franchise-locations__picker">
                <p className="title">Aktuell mögliche Städte</p>
                <p className="city">{locations[activeLocation]}</p>
                <div className="cta">
                    <div className="previous" onClick={previousLocation}>
                        <ChevronLeft color="#00E940" />
                    </div>
                    <div className="next" onClick={nextLocation}>
                        <ChevronRight color="#00E940" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Locations;
